import { createSlice } from '@reduxjs/toolkit';
import { IPermissionsContent, IPermissionsState } from '../../types/store';

const initialState: IPermissionsState = {
  content: [],
  page: {
    size: 0,
    number: 0,
    totalElements: 0,
    totalPages: 0,
  },
};

const permissionsSlice = createSlice({
  name: 'permissionsSlice',
  initialState,
  reducers: {
    setPermissions: (state, action) => {
      state.content = action.payload.content;
      state.page = action.payload.page;
    },
    addPermission: (state, action) => {
      const newPermission = action.payload as IPermissionsContent;
      state.content.push(newPermission);
      state.page.totalElements++;
    },
    updatePermission: (state, action) => {
      const updated = action.payload as IPermissionsContent;
      const index = state.content.findIndex((x: IPermissionsContent) => x.id === updated.id);
      if (index !== -1) state.content[index] = updated;
    },
    removePermission: (state, action) => {
      console.log('got here');
      state.content = state.content?.filter((x: IPermissionsContent) => x.id != action.payload);
      console.log('state.content', state.content);
      state.page.totalElements--;
    },
  },
});

export const { setPermissions, addPermission, updatePermission, removePermission } =
  permissionsSlice.actions;

export default permissionsSlice.reducer;
